import React from 'react';

type ButtonTone = 'default' | 'on-dark';

type ButtonOwnProps<C extends React.ElementType> = {
  as?: C;
  tone?: ButtonTone;
  className?: string;
  children?: React.ReactNode;
};

type PrimaryButtonProps<C extends React.ElementType> = ButtonOwnProps<C> &
  Omit<React.ComponentPropsWithoutRef<C>, keyof ButtonOwnProps<C>>;

const TONE_CLASS: Record<ButtonTone, string> = {
  default: 'bg-we-ink text-we-bg',
  'on-dark': 'bg-we-bg text-we-ink',
};

const LAYOUT =
  'rounded-full px-7 py-3.5 font-bold hover:-translate-y-px transition-transform';

function PrimaryButton<C extends React.ElementType = 'button'>({
  as,
  tone = 'default',
  className = '',
  children,
  ...rest
}: PrimaryButtonProps<C>) {
  const Component = as ?? 'button';
  return (
    <Component className={`${TONE_CLASS[tone]} ${LAYOUT} ${className}`.trim()} {...rest}>
      {children}
    </Component>
  );
}

export default PrimaryButton;
